import { parseNumeric, postRequest } from '../../../shared/utils';
import { resolveRecipientsWithNpiManagerFallback } from './notificationRecipients';

type NpiSteeringMeDoneRow = {
  id1: number | string;
  htz?: string | number | null;
  pf_lc?: number | string | null;
};

type MeToAvNewComponentPayload = {
  screen: 'NPI_STEERING';
  rowId: number;
  pkey: 'id1';
  schemaName: 'npi';
  tableName: 'sheet1';
  screenGridId: number;
  messageKey: 'npiSteering.me_to_av_new_component_message';
  messageParams: {
    id1: string;
    pf_lc: string;
  };
  actionConfig: {
    allowReject: false;
  };
};

type CreateMeToAvNewComponentNotificationParams = {
  row: NpiSteeringMeDoneRow;
  screenGridId: number;
  createdBy: number;
  valueOptionsProfitCenter: { label: string; value: number }[];
  configSchema: string;
};

/**
 * Creates a ME->AV notification for rows transitioned to work-preparation done.
 */
export async function createMeToAvNewComponentNotification({
  row,
  screenGridId,
  createdBy,
  valueOptionsProfitCenter,
  configSchema,
}: CreateMeToAvNewComponentNotificationParams) {
  const rowId = parseNumeric(row.id1);
  const pcnrId = parseNumeric(row.pf_lc);
  const pcnrLabel =
    valueOptionsProfitCenter.find((option) => option.value === pcnrId)?.label ?? String(pcnrId);

  if (rowId == null || pcnrId == null) {
    return null;
  }

  const userIds = await resolveRecipientsWithNpiManagerFallback({
    screenGridId,
    pcnrId,
    configSchema,
  });
  if (!userIds.length) {
    return null;
  }

  const notificationRowId = String(rowId);
  const payload: MeToAvNewComponentPayload = {
    screen: 'NPI_STEERING',
    rowId,
    pkey: 'id1',
    schemaName: 'npi',
    tableName: 'sheet1',
    screenGridId,
    messageKey: 'npiSteering.me_to_av_new_component_message',
    messageParams: {
      id1: notificationRowId,
      pf_lc: pcnrLabel,
    },
    actionConfig: {
      allowReject: false,
    },
  };

  const result = await postRequest('/api/notification/createNotification', {
    type: 'ME_TO_AV_NEW_COMPONENT',
    payload,
    createdBy,
    userIds,
    status: 'UNREAD',
    message: `Part with NPI ID ${notificationRowId} is ready for work preparation. Profit Center: ${pcnrLabel}`,
  });

  return result;
}
